/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';

// import { IListRankingReturn } from '../interfaces/ranking';
import { RankingStatusManager } from '../services/manager';
// import { getAllRankings, getRankingBySport, getRankingBySportPaginated } from '../services/ranking';
import { rankingActions } from './definition';
import { getAllRankings } from '../services/ranking';

function rankingError(e: string, commune: any) {
    return {
        type: rankingActions.RANKING_ERROR,
        error: e,
        data: commune,
    };
}

// Reducers of Single Ranking
function rankingIsLoading() {
    return {
        type: rankingActions.RANKING_IS_LOADING,
    };
}

const rankingListReset = () => {
    return {
        type: rankingActions.RANKING_RESET,
    };
};

// Recuders of Ranking Collection
// function rankingIsLoadingList() {
//     return {
//         type: rankingActions.RANKING_IS_LOADING,
//     };
// }

// function rankingErrorList(e: string) {
//     return {
//         type: rankingActions.RANKING_ERROR,
//         error: e,
//     };
// }

function rankingSetList(rankings: any) {
    return {
        type: rankingActions.RANKING,
        data: rankings,
    };
}

/**
 * Reducer to rest a rankings
 * @param values Data to reset rankings
 */
export const resetStateRanking = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(rankingListReset());
    };
};

/**
 * Reducer to rest a rankings
 * @param values Data to reset rankings
 */
export const resetRankingReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(rankingListReset());
    };
};

/**
 * Reducer to reset Rankings
 * @param values Values to reset rankings
 */
export const resetRanking = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(rankingListReset());
    };
};

// List

/**
 * Reducer to get a ranking by sport paginated
 * @param query
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getRankingBysportPaginated = (query) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(rankingIsLoading());
        try {
            const response = await getAllRankings(query);
            if (response?.statusCode === RankingStatusManager.RANKINGS_LISTED && response.data) {
                // console.log(response);
                dispatch(rankingSetList(response));
            } else {
                dispatch(rankingError('Could not get ranking: ', query.sportId));
            }
        } catch (error: any) {
            const Err = {
                data: query.sportId,
                message: error,
                code: 'NOT_FOUND',
            };
            dispatch(rankingError('No se pudo obtener el ranking', Err));
        }
    };
};
